import { createStore } from 'vuex';
import axios from 'axios';

async function ComprobarToken(commit) {
  const tokenString = localStorage.getItem('token');
  let token;

  if (tokenString && tokenString !== "null") {
    token = tokenString;

    try {
      const verify = {
        token: token
      };
      const apiUrl = process.env.VUE_APP_API_URL+'/api/token/verify';
      console.log(apiUrl)
      await axios.post(apiUrl, verify);
      return true;
    } catch (error) {
      const refresh = localStorage.getItem('refresh');

      if (refresh !== null) {
        const refreshObj = {
          refresh: refresh
        };
        const apiRefresh = process.env.VUE_APP_API_URL+'/api/token/refresh';

        try {
          const response = await axios.post(apiRefresh, refreshObj);
          commit('login', response.data);
          return true;
        } catch (error) {
          localStorage.setItem('refresh', null);
          localStorage.setItem('token', null);
          console.error(error);
          return false;
        }
      } else {
        console.error('No refresh found in localStorage');
        localStorage.setItem('refresh', null);
        localStorage.setItem('token', null);
        return false;
      }
    }
  } else {
    console.error('No token found in localStorage');
    localStorage.setItem('refresh', null);
    localStorage.setItem('token', null);
    return false;
  }
}


const store = createStore({
  state: {
    token: localStorage.getItem('token'),
    refresh: localStorage.getItem('refresh'),
    isLoggedIn: false,
    input: JSON.parse(localStorage.getItem("input")) || {},
  },
  mutations: {
    login(state, data) {
      state.isLoggedIn = true;
      if (data.access){
        console.log("token metido")
        state.token = data.access;
        localStorage.setItem('token', data.access)
      }
      if (data.refresh && data.refresh != null){
        console.log("refresh metido")
        state.refresh = data.refresh
        localStorage.setItem('refresh', data.refresh)
      }
    },
    logout(state) {
      localStorage.setItem('refresh', null);
      localStorage.setItem('token', null);
      localStorage.setItem('partner_token', null);
      state.isLoggedIn = false;
    },
    setLoggedIn(state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn;
    },
    setInput(state, input) {
      state.input = input;
      localStorage.setItem('input', JSON.stringify(input))
    }
  },
  actions: {
    async initialice({ commit }) {
      const isLoggedIn = await ComprobarToken(commit);
      console.log("comprobar token")
      commit('setLoggedIn', isLoggedIn);
    },
    setToken({ commit }, data) {
      commit('login', data);
    },
    setInput({ commit }, input) {
      commit('setInput', input);
    }
  }
});

export default store;
